import './SingleIndustries.scss';

import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PATH, RouteParams } from '../../../../router';
import { useDataQuery, useGTMDataSend } from '../../../../common/hooks';
import { querySingleIndustries, mutationMainForm } from '../../../../network';
import { cn } from '../../../../ui/utils/bem';
import { Breadcrumbs } from '@dataartdev/uikit/Breadcrumbs';
import { ContentBuilder } from '../../../../common/components/ContentBuilder/ContentBuilder';
import { recaptchaKey, recaptchaFormKey } from '../../../../common/constants';
import { useIntl } from 'react-intl';
import { useLetsTalkFormDictionary } from '../../../../common/hooks/useLetsTalkFormDictionary';
import { useRedirect404 } from '../../../../common/hooks/useRedirect404';

const cnSingleIndustries = cn('SingleIndustries');

type Props = RouteComponentProps<RouteParams> & {};

const SingleIndustries: React.FC<Props> = ({ match, history }) => {
  const { locale } = useIntl();
  const { data, loading, error } =
    useDataQuery(querySingleIndustries, {
      slug: match.params.slug,
      locale,
    }) || {};

  const {
    companySiteCaseStudy,
    dictionariesForm,
  } = useLetsTalkFormDictionary();
  const { breadcrumbs = [], content, metaTitle } = data || {};

  useRedirect404(error, history);
  useGTMDataSend(metaTitle);

  return (
    <div
      className={cnSingleIndustries({ breadcrumbs: breadcrumbs?.length > 0 })}
    >
      {!loading && (
        <>
          {breadcrumbs?.length > 0 && (
            <div className="container">
              <div className={cnSingleIndustries('Breadcrumbs')}>
                <Breadcrumbs
                  getLabel={page => page.text}
                  getLink={page => page.url}
                  history={history}
                  pages={breadcrumbs}
                />
              </div>
            </div>
          )}
          {content && content.length > 0 && (
            <div className={cnSingleIndustries('Content')}>
              <ContentBuilder
                items={content}
                aliases={PATH}
                studyCardBtnText={
                  companySiteCaseStudy?.companySiteCaseStudyCardText
                }
                recaptchaKey={recaptchaKey}
                onSubmitForm={async body =>
                  await mutationMainForm({
                    body: { ...body, pageId: data?.id },
                    [`${recaptchaFormKey}`]: body.token,
                  })
                }
                pageId={data?.id}
                dictionariesForm={dictionariesForm}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SingleIndustries;
